import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import cx from 'classnames';

import { useId, useInputBooleanValue } from 'utilsTS/hooks';

import { inputPropTypes } from './inputPropTypes';
import { LabeledInput } from './components';

export interface ManagedRadioInputProps extends React.ComponentPropsWithoutRef<'input'> {
    innerRef?: React.Ref<HTMLInputElement>;
    label?: React.ReactNode;
    onBeforeChange?: (
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean,
    ) => void | boolean;
}

export const ManagedRadioInput: React.FC<ManagedRadioInputProps> = ({
    id: defaultId,
    innerRef,
    label,
    value,
    checked: controlledChecked,
    defaultChecked,
    readOnly,
    onClick = noop,
    onChange = noop,
    onBeforeChange = noop,
    className,
    ...rest
}) => {
    const id = useId('radio', defaultId);
    const [checked, handleChange] = useInputBooleanValue(defaultChecked, controlledChecked, {
        readOnly,
        onBeforeChange,
        onChange,
    });

    return (
        <LabeledInput
            htmlFor={id}
            label={label}
            className={cx('custom-radio', className)}
            onClick={onClick}
        >
            <input
                {...rest}
                ref={innerRef}
                id={id}
                type="radio"
                value={value}
                checked={checked}
                className="custom-control-input"
                onChange={handleChange}
                onClick={onClick}
            />
        </LabeledInput>
    );
};

ManagedRadioInput.displayName = 'ManagedRadioInput';
ManagedRadioInput.propTypes = {
    ...inputPropTypes,
    id: PropTypes.string,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onClick: PropTypes.func,
};
